const kapitolColors = {
  text: "#4D5D66",
  cta: "#00B8A6",
  darkGreen: "#006470",
  darkGreen40: "#85C1C6",

  titaniumGrey: "#657C88",
  titaniumGrey20: "#CBD0D2",

  nightBlue: "#00212F",
  blue: "#004C64",
  lightBlue: "#DBE9EB",
  lightBlue50: "#EAF4F5",
  insuranceLightBlue: "#E1EEF5",
  insuranceBlue: "#76B4CF",

  skyGrey: "#9AAAB2",
  skyGrey20: "#EBEEF0",

  gold: "#AD9752",
  goldCta: "#4D5D66",

  realBlue: "#004E66",
};

export { kapitolColors };
